//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      mounted: false
    }
  },
  mounted() {
    this.mounted = true
  },
  props: {
    blok: {
      type: Object,
      default: () => {}
    },
    customStyle: {
      type: String,
      default: ''
    }
  }
}
